import React, { createContext, useContext, ReactNode, useState } from 'react';
import { useCookies } from 'react-cookie';

type UserInfo = {
  userId: string;
  username: string;
  userName: string;
  warehouseId: string;
};

type UserContextType = [UserInfo | null, (info: UserInfo | null) => void];

const UserContext = createContext<UserContextType | undefined>(undefined);

export const COOKIES_USER_INFO = 'user-info';

export const useUserInfo = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

export const UserInfoProvider = ({ children }: { children: ReactNode }) => {
  const [cookies, setCookies, removeCookies] = useCookies([COOKIES_USER_INFO]);
  const [userInfo, setUserInfoState] = useState<UserInfo | null>(cookies[COOKIES_USER_INFO] ? cookies[COOKIES_USER_INFO] : null);

  const setUserInfo = (info: UserInfo | null) => {
    if (info) {
      setCookies(COOKIES_USER_INFO, info);
      setUserInfoState(info);
    } else {
      removeCookies(COOKIES_USER_INFO);
      setUserInfoState(null);
    }
  };

  return <UserContext.Provider value={[userInfo, setUserInfo]}>{children}</UserContext.Provider>;
};
